import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ActionCardProps {
  title: string;
  subtitle: string;
  icon: BoxIcon;
  onClick?: () => void;
  delay?: number;
  primary?: boolean;
}
export function ActionCard({
  title,
  subtitle,
  icon: Icon,
  onClick,
  delay = 0,
  primary = false
}: ActionCardProps) {
  return <motion.button initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay,
    duration: 0.4,
    ease: 'easeOut'
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`
        w-full p-6 rounded-2xl text-left transition-shadow duration-300
        flex items-center gap-5 group
        ${primary ? 'bg-[#E63946] text-white shadow-lg shadow-red-200 hover:shadow-xl hover:shadow-red-300' : 'bg-white text-gray-800 shadow-sm hover:shadow-md border border-gray-100'}
      `} data-id="element-5">
      <div className={`
        p-3 rounded-xl flex-shrink-0 transition-colors
        ${primary ? 'bg-white/20 text-white' : 'bg-gray-50 text-[#E63946] group-hover:bg-red-50'}
      `} data-id="element-6">
        <Icon size={28} strokeWidth={2} data-id="element-7" />
      </div>

      <div className="flex-1" data-id="element-8">
        <h3 className={`text-lg font-bold mb-0.5 ${primary ? 'text-white' : 'text-gray-900'}`} data-id="element-9">
          {title}
        </h3>
        <p className={`text-sm ${primary ? 'text-red-100' : 'text-gray-500'}`} data-id="element-10">
          {subtitle}
        </p>
      </div>
    </motion.button>;
}